import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { BannerInfoKey } from '../queries/banner-info.query-base';

export interface BannerClosedParams {
	readonly key: BannerInfoKey;
}

export class BannerClosedCommand extends Command<BannerClosedParams, void> { }

export class BannerClosedCommandHandlerBase implements CommandHandler<BannerClosedCommand, BannerClosedParams, void> {
	private static Url = TaggedUrl.join('user/banner', [Tags.Api]);

	public constructor(
		private readonly http: HttpService
	) {}

	public async handleAsync(command: BannerClosedCommand): Promise<void> {
		await this.http.post(BannerClosedCommandHandlerBase.Url, command.params);
	}
}